(function () {
  'use strict';

  function setSelected(root, btn) {
    root.querySelectorAll('.babag-pdp-variants__item').forEach(function (el) {
      el.classList.remove('is-selected');
      el.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');
  }

  function syncForm(variantId) {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.querySelectorAll('select[name="id"], input[name="id"]').forEach(function (input) {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function updatePrice(btn) {
    var html = btn.getAttribute('data-price-html');
    if (!html) return;
    var decoded = document.createElement('textarea');
    decoded.innerHTML = html;
    var priceHtml = decoded.value;
    document.querySelectorAll('#price_ppr, .entry-summary p.price_range').forEach(function (el) {
      el.innerHTML = priceHtml;
    });
  }

  function onPick(root, btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    setSelected(root, btn);
    syncForm(variantId);
    updatePrice(btn);
  }

  function init(root) {
    if (root.getAttribute('data-babag-ready')) return;
    root.setAttribute('data-babag-ready', '1');
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.babag-pdp-variants__item');
      if (!btn || !root.contains(btn)) return;
      onPick(root, btn);
    });
  }

  function boot() {
    document.querySelectorAll('[data-babag-pdp-variants]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
